// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Br2Hx","name":"Header_name__1jVDm","birthday":"Header_birthday__3kjoP","skeleton":"Header_skeleton__sjvw_"};